import React from 'react'
import { DataTable } from 'primereact/datatable'
import { enums } from '../../../constants'
import utils from '../../../utils/index'
import { Card } from 'primereact/card'
import { TabPanel, TabView } from 'primereact/tabview'
import _ from 'lodash'
import LtsTextArea from '../../../components/lottus/lts-text-area'

export const ConsultaRemessaPagamentoForm = (props) => {
  const record = props.record
  const itens = _.get(record, 'itens', [])

  // const logs = _.get(record, 'logs', [])

  function getDadosGerais() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <DataTable
            selection={props.selection}
            onSelectionChange={props.onSelectionChange}
            reorderableColumns={true}
            resizableColumns={true}
            columnResizeMode="expand"
            ref={props.dataTableItens}
            paginator={true}
            emptyMessage=" "
            rows={15}
            rowsPerPageOptions={enums.ROWSPERPAGEOPTIONS}
            value={itens}
            onRowSelect={props.onRowSelect}
            totalRecords={itens.length}
          >
            {props.colunasItens}
          </DataTable>
          <br />
          <div style={{ textAlign: 'right', margin: '7px' }}>
            <strong>Total: </strong> {itens.length}
          </div>
        </div>
      </div>
    )
  }

  const resolveErro = () => {
    const erro = _.get(record, 'erro', '')
    if (_.isEmpty(erro)) {
      return null
    }
    return <LtsTextArea value={erro} disabled={true} cols={200} />
  }

  function getContent() {
    return (
      <div>
        {resolveErro()}
        <TabView activeIndex={props.state.activeIndex} onTabChange={(e) => props.changeActiveIndex(e.index)}>
          <TabPanel header="Dados Gerais">{getDadosGerais()}</TabPanel>
        </TabView>
      </div>
    )
  }

  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <Card
          title={`${utils.getMessage(props.messages, 'consultaremessapagamento.label.consultaRemessasPagamentos')} ${
            record.oid || ''
          }`}
          subTitle={_.get(record, 'idTransacao', '')}
        >
          {getContent()}
        </Card>
      </div>
    </div>
  )
}
